import React from 'react';
import ApplicationMenuWrapper from './ApplicationMenuWrapper';
import { TIMETABLE_PATH } from '../../../constants/routes';

const SelectEventMenu = ({ events, selected, closeMenu, open, onClick, selectedId }) => (
    <div className="ckp-application-menu-select">
        <ApplicationMenuWrapper open={open} closeMenu={closeMenu}>
            <div onClick={onClick} className="ckp-application-menu-select-label">
                Select Event
            </div>
            <span className="ckp-modal-full-line" />
            <div>
                {events.map(ev => (
                    <React.Fragment key={ev.value}>
                        <a
                            className={`ckp-application-menu-select-option ${selectedId === ev.value ? 'is-bold' : ''}`}
                            href={TIMETABLE_PATH.replace(':id', ev.value)}
                        >
                            <span>{ev.label}</span>
                        </a>
                        <span className="ckp-modal-full-line is-sub" />
                    </React.Fragment>
                ))}
            </div>
        </ApplicationMenuWrapper>
        <div onClick={onClick} className="ckp-application-menu-select-current">
            {selected.name || 'Select event'}
        </div>
    </div>
);

export default SelectEventMenu;



// WEBPACK FOOTER //
// ./src/components/application/menu/SelectEventMenu.js